import { AfterViewInit, Component, Input, OnInit, Renderer2 } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { BsModalRef } from 'ngx-bootstrap';
import { Subject } from 'rxjs';
import { PlantingSiteDto } from 'src/app/models/trofaco/plantingSiteDto';
import { NgoPartnerDto } from 'src/app/models/trofaco/ngoPartnerDto';
import { PlantingSiteSpeciesDto } from 'src/app/models/trofaco/plantingSiteSpeciesDto';

@Component({
  selector: 'app-modal-planting-site-details',
  templateUrl: './modal-planting-site-details.component.html',
  styleUrls: ['./modal-planting-site-details.component.css']
})
export class ModalPlantingSiteDetailsComponent implements OnInit, AfterViewInit {

  constructor(private _renderer2: Renderer2, private _bsModalService: BsModalRef) { }
  @Input()
  site: PlantingSiteDto = {};
  @Input()
  isLandOwner: boolean;
  @Input()
  ngoPartner: NgoPartnerDto = {};
  @Input()
  plantingSiteSpecies: PlantingSiteSpeciesDto = {};

  photoUrl?: string | SafeUrl;
  description?: string;
  private _onDestroy$ = new Subject();

  ngOnInit() {
    if (this.isLandOwner) {
      if (this.site.landOwnerPhoto) {
        this.photoUrl = this.site.landOwnerPhoto.originalUrl;
      }
      this.description = this.site.landOwnerDescription;
    }
    else if (this.ngoPartner) {
      if (this.ngoPartner.photo) {
        this.photoUrl = this.ngoPartner.photo.originalUrl;
      }
      this.description = this.ngoPartner.description;
    }
    else if (this.plantingSiteSpecies) {
      this.photoUrl = this.plantingSiteSpecies.photoUrl;
      this.description = this.plantingSiteSpecies.description.replace(/[\n]/g, '<br>');
    }
  }

  ngAfterViewInit() {
    if (this.photoUrl) {
      if (this.isLandOwner) {
        const image: HTMLElement = document.getElementsByClassName("haveimage")[0] as HTMLElement;
        if (image != undefined)
          image.setAttribute('style', 'background-color:transparent !important;');
      }
      else {
        const image: HTMLElement = document.getElementsByClassName("haveimage")[0] as HTMLElement;
        if (image != undefined)
          image.setAttribute('style', 'background-color:transparent !important;');
      }
    }
  }

  ngOnDestroy(): void {
    this._onDestroy$.next();
    this._onDestroy$.complete();
    const body = document.getElementsByTagName("body")[0];
    this._renderer2.removeClass(body, "modal-open");
  }

  hideNavModal() {
    this._bsModalService.hide();
  }
}
